'use strict'

export default function ( $timeout )
{

	function _apply ( element )
		{
			var $container = document.querySelector(element.getAttribute('scroll-container'))

			;($container !== null) 
				? _init(element, $container) 
				: $timeout(function(){ _apply(element) }, 100)
		}

	function _init ( element, $container )
		{
			var $scroll = $container.querySelector('.content'),
				$offset = findPage(element),
				params = getParams(element)

			angular.forEach(params, function ( p ){
				$scroll.addEventListener('scroll', function ( e ) {
					var add = '',
						current = ($scroll.scrollTop - $offset.offsetTop) / window.innerHeight,
						max = Math.max(p.to, p.from),
						min = Math.min(p.to, p.from),
						pos

					current = (current < 0.5) ? 4*current*current*current : (current-1)*(2*current-2)*(2*current-2)+1

					pos = max - (current * (max - min) * p.mult)

					switch (p.prop)
					{
						case 'top':
						case 'bottom':
						case 'left':
						case 'right':
							element.style.position = 'relative'
							add = 'px'
							break;
					}

					element.style.transition = 'none'
					element.style[p.prop] = pos + add
				})
			})
		}

	function findPage ( element )
		{
			var parent = element.parentElement

			while (parent.getAttribute('sub-page') === null)
			{
				parent = element.parentElement
			}

			return parent
		}

	function getParams ( element )
		{
			var params = element.getAttribute('scroll-response').split(';')

			return params.map(getParam(element))
		}

	function getParam ( element )
		{
			return function ( params )
			{
				params = params.split(':')

				;(params[3] === undefined) && (params[3] = 1)
				
				;(typeof params[1] === 'string' && params[1].indexOf('%') > -1) && (params[1] = window.innerHeight / 100 * parseInt(params[1]))
				;(typeof params[2] === 'string' && params[2].indexOf('%') > -2) && (params[2] = window.innerHeight / 100 * parseInt(params[2]))

				return {
					prop: params[0],
					from: parseInt(params[1]),
					to: parseInt(params[2]),
					mult: parseFloat(params[3])
				}
			}
		}

	return {
		restrict: 'A',
		scope: {},
		link: function ( scope, elements, attrs )
			{
				angular.forEach(elements, _apply)
			}
	}
}


// WEBPACK FOOTER //
// ./src/app/directives/scroll-response/scroll-response.directive.js